import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RESTServerRoute } from '../../types/Server';
import { DailyReport } from '../../types/Chatbot';
import { API_VERSION_CTX, ApiVersion } from '../../types/api';
import { SKIP_AUTO_DISCONNECT } from '../../interceptors/auto-disconnect/auto-disconnect.interceptor';

@Injectable({
  providedIn: 'root',
})
export class ChatDailyReportApiService {
  public constructor(private readonly httpClient: HttpClient) {}

  public getLatestReport(): Observable<DailyReport> {
    return this.httpClient.get<DailyReport>(RESTServerRoute.REST_DAILY_REPORT_LATEST, {
      context: new HttpContext().set(API_VERSION_CTX, ApiVersion.V2).set(SKIP_AUTO_DISCONNECT, true),
    });
  }
}
